import { AxiosInstance } from 'axios';
import authHeader from './auth_header';
import axiosInstance from "./axios_instance";

const ApiPath = "/api/accounts/password";

class AccountService {
    private instance: AxiosInstance;
    private readonly navigate: any;

    constructor(navigate: any) {
        this.instance = axiosInstance(navigate);
        this.navigate = navigate;
    }

    async changePassword(password: string) {
        const headers = authHeader(this.navigate);
        const data = {newPassword: password}
        return await this.instance.put(ApiPath, data, { headers });
    }
}

export default AccountService;